module.exports = __webpack_public_path__ + "static/media/galvan-patricio.5de0d438.jpg";